import React from 'react';
import { Helmet } from 'react-helmet';

export default function SEOHead() {
  return (
    <Helmet>
      <title>Henry Shih | Software Engineer</title>
      <meta name="description" content="Software Engineer specializing in building user-focused web applications with modern technologies." />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://henry-shih.netlify.app/" />
      <meta property="og:title" content="Henry Shih | Software Engineer" />
      <meta property="og:description" content="Software Engineer specializing in building user-focused web applications with modern technologies." />
      <meta property="og:image" content="https://your-website.com/path-to-preview-image.jpg" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content="https://your-website.com/" />
      <meta property="twitter:title" content="Henry Shih | Software Engineer" />
      <meta property="twitter:description" content="Software Engineer specializing in building user-focused web applications with modern technologies." />
      <meta property="twitter:image" content="https://your-website.com/path-to-preview-image.jpg" />

      {/* Additional SEO tags */}
      <meta name="keywords" content="software engineer, web development, react, javascript, python, full stack developer" />
      <link rel="canonical" href="https://henry-shih.netlify.app/" />
    </Helmet>
  );
} 